import React, { useMemo, useState } from 'react';
import { useWorkplacesQuery } from '../../../../graphql/graphql';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import MultiSelectWithCheckList from '../../../Base/Components/Inputs/MultiSelectWithCheckList/MultiSelectWithCheckList';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
	includeRoot?: boolean;
	portal?: boolean;
}

const WorkplaceMultiSelectWithCheckList: React.FC<Props> = props => {
	const { value, onChange, includeRoot = false, portal } = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);
	const [isReady, setIsReady] = useState(false);
	const { data, isLoading } = useWorkplacesQuery({
		type: !includeRoot ? 'normal' : undefined,
		pagination: {
			take: 999,
		},
	});

	const options: SelectValue[] = useMemo(() => {
		setIsReady(false);
		const items: SelectValue[] = [];

		for (const workplace of data?.workplaces?.data || []) {
			if (workplace) {
				items.push({
					value: workplace.id,
					label: workplace.doctorDisplayName || '',
				});
			}
		}

		setIsReady(true);
		return items;
	}, [data]);

	if (isReady) {
		return (
			<MultiSelectWithCheckList
				{...props}
				options={options}
				onChange={onChange}
				value={defaultValue?.label ? defaultValue : value}
				portal={portal}
			/>
		);
	}

	return null;
};

export default WorkplaceMultiSelectWithCheckList;
